export default __webpack_public_path__ + "static/media/RU.f57e83bf.svg";